import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TokenService } from './token.service';
import { environment } from "@env/environment";
import { map } from "rxjs/operators";

export type ProviderType = 'hotel' | 'flight' | 'train' | 'car' | 'expense';
export interface ProviderItem {
  type: ProviderType;
  name: string;
  integrated?: boolean;
  uuid?: string;
}

@Injectable({
  providedIn: 'root'
})
export class ProvidersService {

  constructor(private http: HttpClient, private tokenService: TokenService) {}

  private get headers() {
    const token = this.tokenService.getToken();
    return { Authorization: `JWT ${token}` };
  }

  getProviders(type?: ProviderType) {
    let params = new HttpParams();
    if (type) params = params.set('type', type);
    return this.http.get<ProviderItem[]>(
      `${environment.baseUrlApi}/providers`,
      { headers: this.headers, params }
    );
  }

  createProvider(type: ProviderType, name: string) {
    const body = { type, name };
    return this.http
      .post<ProviderItem>(`${environment.baseUrlApi}/providers`, body, {
        headers: this.headers,
      })
      .pipe(map((res) => res));
  }

  deleteProvider(type: ProviderType, name: string) {
    const params = new HttpParams().set('type', type).set('name', name);
    return this.http.delete<void>(`${environment.baseUrlApi}/providers`, {
      headers: this.headers,
      params,
    });
  }

}
